import React, { useEffect } from 'react'
import { useProtectedHidden, useVision } from './visionContext'
import VisionBlurPlaceholder from './VisionBlurPlaceholder'

/**
 * Story 213 v2 — a sensitive boundary (C7.1). It exists only when Sun served the content with
 * `sensitive: true` or the route is a marked screen (H-v2-19); otherwise it renders its children as today.
 * While the vigilance is covered in SENSITIVE_ONLY its children are UNMOUNTED (not hidden) and the blurred placeholder
 * takes their place (reopening 3, C15.6: the same for every piece, reason and profile, with no action, DK-2); uncovering
 * mounts them again, so they ask Sun for their data again (RN24). While viewed it renders its children and nothing else
 * (DK-1: no "Protected" label). While mounted it counts as "still viewing something sensible" for the guard's leave (RN9).
 * `compact` serves small boundaries (a 110 px document thumbnail): the small placeholder (S243).
 */
const SensitiveBoundary = ({ sensitive = false, compact = false, children }) => {
  const { registerBoundary } = useVision()
  const protectedHidden = useProtectedHidden()

  useEffect(() => {
    if (!sensitive) {
      return
    }
    return registerBoundary()
  }, [sensitive, registerBoundary])

  if (!sensitive) {
    return <>{children}</>
  }
  if (protectedHidden) {
    return (
      <div data-sensitive-boundary style={compact ? { width: '100%', height: '100%' } : { margin: '8px 0' }}>
        <VisionBlurPlaceholder size={compact ? 'small' : 'block'} />
      </div>
    )
  }
  return (
    <div data-sensitive-boundary style={{ display: 'contents' }}>
      {children}
    </div>
  )
}

export default SensitiveBoundary
